import React from "react";
import { lazy } from "react";
import { useSelector } from "react-redux";

import { Navigate, Route, Routes } from "react-router-dom";
import Deliveries from "../Interface/DASHBOARD/Deliveries/Deliveries";
import Errorpage from "../NotFound/Errorpage";
const MyNotification = lazy(() =>
  import("../Interface/Components/MyNotification")
);
/* dashboard start */
const Profile = lazy(() =>
  import("../Interface/DASHBOARD/ProfilePage/Profile")
);
const AccountSet = lazy(() =>
  import("../Interface/DASHBOARD/AccountSettings/Settings/AccountSet")
);
const VendorDashboard = lazy(() =>
  import("../Interface/DASHBOARD/Vendors/VendorDashboard")
);
const MyPayment = lazy(() =>
  import("../Interface/DASHBOARD/Vendors/MyPayment")
);
const UploadProd = lazy(() =>
  import("../Interface/Products/UploadProductjs/UploadProd")
);

const ProfileRoute = () => {
  const { currentUser, isGettingUser, isUserGettingError } = useSelector(
    (state) => state.User
  );

  if (isGettingUser) {
    return "loading...";
  }
  if (isUserGettingError) {
    alert("error getting user");
    return <Navigate to="/" />;
  }

  /* check if the getting user from DB is false and the loading state for getting user is false before redirecting the user outside the profile page  */
  // if (!isGettingUser && currentUser) {
  if (currentUser)
    return !isGettingUser && !isUserGettingError && currentUser ? (
      <Routes>
        <Route
          index
          element={
            <React.Suspense fallback={<div>loading...</div>}>
              <Profile />
            </React.Suspense>
          }
        ></Route>
        {/* Account Settings */}
        <Route
          path="AccountSettings"
          element={
            <React.Suspense fallback={<div>Loading...</div>}>
              <AccountSet />
            </React.Suspense>
          }
        ></Route>

        <Route
          path="/my_notification"
          element={
            <React.Suspense fallback={<div>Loading</div>}>
              <MyNotification />
            </React.Suspense>
          }
        ></Route>

        <Route
          path="my_payment"
          element={
            <React.Suspense fallback={<div>Loading</div>}>
              <MyPayment />
            </React.Suspense>
          }
        ></Route>

        {/* vendors */}
        <Route path="/Vendor_dashboard">
          <Route
            index
            element={
              <React.Suspense fallback={<div>Loading</div>}>
                <VendorDashboard />
              </React.Suspense>
            }
          ></Route>
          <Route
            path="upload_product"
            element={
              <React.Suspense fallback={<div>Loading..</div>}>
                <UploadProd />
              </React.Suspense>
            }
          ></Route>
          <Route
            path="Soothe_Tie_Deliveries"
            element={
              <React.Suspense fallback={<div>Loading..</div>}>
                <Deliveries />
              </React.Suspense>
            }
          ></Route>
        </Route>
        <Route path="*" element={<Errorpage />}></Route>
      </Routes>
    ) : (
      <Navigate to="/" />
    );
};
// };

export default ProfileRoute;
